import React from 'react'
// import { NavLink } from 'react-router-dom'

function NavItem ({ isToggle, navList }) {
    return (
        <ul className="lx-flex-row">
            {
                navList.map((item, index) => {
                    return (
                        <li className={`lx-flex-shrink-0 ${isToggle? 'toggle':''}`} key={index}>
                            {
                                item.linkedTarget === '_blank'? (
                                    <a className="lx-flex-row" href={item.linkedUrl} target={item.linkedTarget}>
                                        <span className="title">{ item.name }</span>
                                    </a>
                                ):(
                                    <a exact className="lx-flex-row" href={item.linkedUrl} target={item.linkedTarget}>
                                        <span className="title">{ item.name }</span>
                                    </a>
                                )
                            }
                        </li>
                    )
                })
            }
        </ul>
    ) 
}


export default NavItem;